import React, { createContext, useContext } from "react";

/**
 * Carries the form's jurisdiction country (from the tax `metadata.jurisdiction`)
 * down to address fields, which need it to render the correct country-specific
 * address inputs. The forms response no longer ships a top-level jurisdiction
 * object, so the renderer derives the country from `response.metadata`.
 */
const DynamicFormJurisdictionContext = createContext<string | undefined>(
  undefined
);

type ProviderProps = {
  country: string;
  children: React.ReactNode;
};

export const DynamicFormJurisdictionProvider: React.FC<ProviderProps> = ({
  country,
  children
}) => (
  <DynamicFormJurisdictionContext.Provider value={country}>
    {children}
  </DynamicFormJurisdictionContext.Provider>
);

export const useDynamicFormJurisdiction = (): string | undefined =>
  useContext(DynamicFormJurisdictionContext);
